import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAdminUnReadNotification,
  getAdminReadNotification,
  deActiveAdminNotification,
  getProfile,
  deActiveAdminSpecificNotification,
} from '../../redux/action/auth';

const Header = () => {
  const notificationsRef = useRef(null);
  const { profile } = useSelector((state) => state.auth);
  const [showNotifications, setShowNotifications] = useState(false);
  const [notificationType, setNotificationType] = useState('unread');
  const dispatch = useDispatch();
  const { getAdminNotify } = useSelector((state) => state.auth);
  const toggleNotifications = () => {
    setShowNotifications((prev) => !prev);
  };
  const handleClickOutside = (e) => {
    
    if (
      notificationsRef.current &&
      !notificationsRef.current.contains(e.target)
    ) {
      setShowNotifications(false);
    }
  };
  const fetchNotification = (type) => {
    setNotificationType(type);
    if (type == 'unread') {
      dispatch(getAdminUnReadNotification());
    } else {
      dispatch(getAdminReadNotification());
    }
  };
  useEffect(() => {
    
    document.addEventListener('mousedown', handleClickOutside);


    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const readAllAdminNotification = () => {
    dispatch(deActiveAdminNotification());
  };

  const readSpecificAdminNotification = (data) => {
    dispatch(deActiveAdminSpecificNotification(data?._id));
    setTimeout(() => {
      dispatch(getAdminUnReadNotification());
    }, [1000]);
  };
  useEffect(() => {
    dispatch(getAdminUnReadNotification());
    dispatch(getProfile());
  }, [dispatch]);

  const getDaysAgo = (date) => {
    const currentDate = new Date();
    const givenDate = new Date(date);

    const differenceInMilliseconds = currentDate - givenDate;
    const totalDays = Math.floor(
      differenceInMilliseconds / (1000 * 60 * 60 * 24)
    );

    if (totalDays === 0) return 'Today';

    const years = Math.floor(totalDays / 365);
    const months = Math.floor((totalDays % 365) / 30);
    const days = totalDays % 30;

    let result = '';
    if (years > 0) result += `${years} year${years > 1 ? 's' : ''}, `;
    if (months > 0) result += `${months} month${months > 1 ? 's' : ''}, `;
    if (days > 0) result += `${days} day${days > 1 ? 's' : ''} `;

    return result.trim().replace(/,\s*$/, '') + ' ago';
  };


  return (
    <div className='flex justify-between items-center bg-white p-4 shadow'>
     
      <h1 className='text-lg font-semibold'>
        Welcome back, <span className='text-blue-500'>{profile?.name}</span>
      </h1>

      <div className='flex items-center space-x-4'>
        <img
          src={profile?.profilePhoto}
          alt='Profile'
          className='w-8 h-8 rounded-full'
        />

        <div className='relative'>
          <button
            onClick={toggleNotifications}
            className='relative text-lg focus:outline-none'
          >
            <i className='fa fa-bell'></i>
            <span className='absolute top-0 right-0 bg-red-500 text-white text-xs w-4 h-4 rounded-full flex items-center justify-center'>
              {notificationType == 'unread' ? getAdminNotify.length : 0}
            </span>
          </button>

          {showNotifications && (
            <div
              ref={notificationsRef}
              className='absolute right-0 mt-2 w-96 bg-white border border-gray-200 rounded-lg shadow-lg z-50'
            >
    
              <div className='flex border-b'>
                <button
                  onClick={() => fetchNotification('unread')}
                  className={
                    notificationType == 'unread'
                      ? 'flex-1 py-2 text-sm text-center border-b-2 border-blue-500 font-medium'
                      : 'flex-1 py-2 text-sm text-center font-medium'
                  }
                >
                  Unread
                </button>
                <button
                  onClick={() => fetchNotification('read')}
                  className={
                    notificationType == 'read'
                      ? 'flex-1 py-2 text-sm text-center border-b-2 border-blue-500 font-medium'
                      : 'flex-1 py-2 text-sm text-center font-medium'
                  }
                >
                  Read
                </button>
              </div>

             
              <div className='p-4 max-h-80 overflow-y-auto'>
                {' '}
               
                {notificationType === 'unread' ? (
                  <button className='flex items-center space-x-2'>
                    <input
                      type='checkbox'
                      onChange={(e) => {
                        if (e.target.checked) {
                          readAllAdminNotification();
                        }
                      }}
                      className='form-checkbox w-4 h-4 text-blue-600'
                    />
                    <small>Mark All Read</small>
                  </button>
                ) : (
                  ''
                )}
                {getAdminNotify.length > 0 &&
                  getAdminNotify.map((obj, index) => (
                    <div
                      key={obj?._id}
                      className='border p-2 rounded-lg bg-gray-50 my-1'
                    >
                      <span className='flex justify-between'>
                        {notificationType == 'unread' ? (
                          <button className='flex items-center space-x-2'>
                            <input
                              key={obj?._id}
                              type='checkbox'
                              onChange={(e) => {
                                if (e.target.checked) {
                                  readSpecificAdminNotification(obj);
                                }
                              }}
                              className='form-checkbox w-4 h-4 text-blue-600'
                            />{' '}
                            <h5>{obj?.notificationType}</h5>
                          </button>
                        ) : (
                          ''
                        )}

                        <div className='text-xs text-gray-500'>
                          {getDaysAgo(obj?.notificationAt)}
                        </div>
                      </span>

                      <div className='text-xs text-gray-500'>
                        {obj?.userDetails[0]?.name}
                      </div>
                      <p className='text-sm mt-1 text-gray-700'>
                        {obj?.description || obj?.discription}
                      </p>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
